module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-process-details/payroll-process-payroll/payroll-process-payroll.component.css
// module id = ./src/app/hrms/payroll/payroll-process-details/payroll-process-payroll/payroll-process-payroll.component.css
// module chunks = main